var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPoisonSigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.4 38.8",
    style: {
      enableBackground: "new 0 0 23.4 38.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    transform: "translate(-0.154 -0.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    transform: "translate(0.154 0.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    d: "M13.7,18.4c0,0.1,0.1,0.2,0.1,0.3c0.3,1.3-0.4,2-2,2.1c-3.5,0.5-5.1,2.2-4.6,5.2c-3.1,0.9-3.6,2.3-1.6,4.4 c-3,0.4-4.7,1.9-5.1,4.4c-0.5,3.1,1.1,4.4,4.5,4h14.2c0.6,0.1,1.3,0.1,1.9,0.1c0.5,0,1.1-0.3,1.4-0.7c1.8-3,0.8-5.4-2.8-7.2 c0.5-1.7-0.4-3.6-2-4.3c0.1-1.9-0.9-3-3.2-3.1C15.8,21.5,15.6,19.9,13.7,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    d: "M13.7,4.8c-0.2-0.8-0.5-1.5-1-2.1c-0.7-1-1.5-1.9-2.5-2.7c0.3,0.7,0.6,1.3,1,2c0.5,1,0.8,2.1,0.9,3.2 c0.1,0.7,0,1.4-0.1,2.1C11.8,8.3,11.5,9.2,11,10c-0.2,0.4-0.4,0.7-0.5,1.1c-0.6,1.5-0.7,3.1-0.4,4.7c0.1,0.7,0.3,1.4,0.7,2 c0.5,0.7,1.1,1.4,1.8,1.9c-0.2-0.3-0.4-0.7-0.5-1c-0.3-0.7-0.5-1.4-0.6-2.1c0-0.4-0.1-0.7,0-1.1c0-1.6,0.5-3.2,1.3-4.6 c0.3-0.5,0.6-1.1,0.8-1.7C14,7.7,14,6.2,13.7,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    d: "M19,14.4c0.2-0.3,0.4-0.7,0.6-1c-0.6,0.3-1.1,0.8-1.6,1.3c-0.3,0.3-0.5,0.7-0.6,1 c-0.2,0.7-0.2,1.5,0.1,2.1c0.1,0.3,0.3,0.6,0.5,0.8c0.5,0.6,0.7,1.4,0.8,2.2c0,0.2,0,0.4,0,0.5c-0.1,0.4-0.2,0.7-0.4,1 c-0.1,0.2-0.2,0.3-0.3,0.5c0.4-0.2,0.8-0.5,1.1-0.9c0.2-0.3,0.4-0.6,0.4-0.9c0.2-0.8,0.1-1.6-0.2-2.3c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.3-0.4-0.5-0.8-0.6-1.3c-0.1-0.3-0.1-0.7-0.1-1C18.4,15.4,18.6,14.9,19,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    d: "M3.4,15.6c-0.3-0.4-0.6-0.7-1.1-0.9C1.6,14.3,0.8,14,0,13.8c0.4,0.3,0.7,0.5,1.1,0.8 C1.6,15,2,15.6,2.3,16.2c0.1,0.4,0.2,0.7,0.2,1.1c0,0.6-0.1,1.1-0.4,1.6c-0.1,0.2-0.2,0.4-0.3,0.7c-0.2,0.9-0.1,1.8,0.4,2.5 C2.4,22.5,2.7,22.8,3,23c0.5,0.3,1.1,0.5,1.6,0.6c-0.2-0.1-0.4-0.3-0.5-0.4c-0.3-0.3-0.6-0.6-0.8-1c-0.1-0.2-0.2-0.4-0.2-0.6 C3,20.7,3.1,19.8,3.5,19c0.2-0.3,0.3-0.7,0.3-1.1C4.1,17.1,3.9,16.2,3.4,15.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoisonSigns);
export default __webpack_public_path__ + "static/media/icon-poison-signs.5990a623bba38326e95191e94144d760.svg";
export { ForwardRef as ReactComponent };